module.exports = __webpack_public_path__ + "img/cp-logo-small.8e269499.png";